import PublicFactSheetPage from "@app/pages/fact-sheet/public-fact-sheet-page";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute, useParams } from "@tanstack/react-router";

// Public, anonymous company fact sheet at /:slug. Static routes (login,
// sign-up, onboarding, the authed app, ops console) take precedence.
export const Route = createFileRoute("/$slug")({
  head: ({ params }) => pageHead(`${params.slug} fact sheet`),
  component: SlugRoute,
});

function SlugRoute() {
  const { slug } = useParams({ from: "/$slug" });
  return <PublicFactSheetPage slug={slug} />;
}
